<template>
	<row>
		<container>
			<div class="grid lg:grid-cols-2 gap-8 mb-8">
				<div
					class="flex items-center justify-center lg:justify-start mb-14 mt-10 lg:mb-0 lg:mt-0"
				>
					<h2
						class="gradient-title-white text-[50px] lg:text-[54px] font-semibold text-center lg:text-left"
					>
						Why Choose StocksToTrade?
					</h2>
				</div>
				<div class="hidden lg:block">
					<FeatureCard2
						:title="features[0].title"
						:icon="features[0].icon"
						:description="features[0].description"
					/>
				</div>
			</div>

			<div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 lg:hidden">
				<FeatureCard2
					v-for="(feature, index) in features"
					:key="index"
					:title="feature.title"
					:icon="feature.icon"
					:description="feature.description"
				/>
			</div>

			<div class="hidden lg:grid lg:grid-cols-3 gap-8">
				<FeatureCard2
					v-for="(feature, index) in features.slice(1)"
					:key="index"
					:title="feature.title"
					:icon="feature.icon"
					:description="feature.description"
					:class="{ 'col-span-2': index === features.length - 2 }"
				/>
			</div>
		</container>
	</row>
</template>

<script setup>
const features = [
	{
		title: "Everything in One Place",
		icon: "/images/feature-icons/wfeature-icon-1.svg",
		description:
			"Your watchlist, the news, hot stocks, indicators, charts, it's all in one place. No more switching between browsers or platforms."
	},
	{
		title: "Built By Pro Traders",
		icon: "/images/feature-icons/wfeature-icon-2.svg",
		description:
			'7-figure traders created a "shortcut" to help you trade as efficiently as possible.'
	},
	{
		title: "Penny Stock Trades",
		icon: "/images/feature-icons/wfeature-icon-3.svg",
		description:
			"If you’re looking for fast moving penny plays, we’ve pre-built screeners ready to use. Found only with the STT Tool."
	},
	{
		title: "More Time Trading",
		icon: "/images/feature-icons/wfeature-icon-4.svg",
		description:
			"Company earnings, filings, and news are all within one click. Make faster decisions when buying or selling."
	},
	{
		title: "Test Trading Strategy",
		icon: "/images/feature-icons/wfeature-icon-5.svg",
		description:
			"Unlike others, our paper trading capabilities also offer Level 1 real-time data. Found a new strategy? Easily test it without risking real money."
	},
	{
		title: "Elite Technical Tools",
		icon: "/images/feature-icons/wfeature-icon-6.svg",
		description:
			"All the top indicators are pre-loaded including stochastics, RSI, MACD, moving averages and much, much more."
	}
	// {
	//     title: "Integrate Top Brokers",
	//     icon: "/images/feature-icons/wfeature-icon-7.svg",
	//     description: "We’ve partnered with top brokers like E-Trade, Interactive Brokers, Tradier, and more coming soon. No hassle to setup!"
	// }
];
</script>

<style lang="scss" scoped>
div {
}
</style>
